let wid = $WR.define('cheetahApplication/form/DesignerCommonButtonField', [], function (require, exports, module) {
  const HTML = `
  <div class="x-field-editor">
    <div class="basic-editor"></div>
    <div class="form-group">
        <label>动作</label>
        <input name="actionName" type="text" style="width: 120px" readonly>
        <input name="action" type="hidden" class="form-control">
        <button class="x-cmd-select-action">选择</button>
    </div>
    <div class="form-group"><label>点击执行函数</label>
        <div class="controls">
            <div style="height: 150px; border: 1px solid #e5e6e7;">
                <script data-bind="script" data-bind-type="widget" type="text/plain">
                    {xtype: 'CodeEditor', lang: 'Javascript', isFormField: false, showLineNumbers: true}
                </script>
            </div>
        </div>
    </div>
    <div class="controls">
       <div class="checkbox">
           <label><input name="enableInput" data-type="boolean" type="checkbox" value="true">是否可输入</label>
       </div>
   </div>
    <div class="style-editor"></div>
</div>
  `;
  var WidgetClass = require('cheetahApplication/form/CommonButtonField');
  let Comp = MW.extend(require('designer/form/default/Base'), {
    defaults: {
      xtype: 'CommonButtonField',
      xtypeName: '字典选择',
      isFormField: true
    },
    _getTpl: function () {
      return $(HTML)
    },
    getTargetWidgetClass: function () {
      return WidgetClass;
    }
  });

  module.exports = Comp;

});
$WR.defineType({
  id: wid,
  xtype: 'DesignerCommonButtonField',
  designer: ''
});

wid = $WR.define('cheetahApplication/form/CommonButtonField', [], function (require, exports, module) {
  const HTML = `
          <div class="x-imbedded-selection">
            <span class="value"></span>
            <a class="button">选择</a>
        </div>
        `
  const inputHtml = `<div class="input-group">
          <input type="text" class="form-control" autocomplete="off" {attrs:attributes}/>
          <a class="input-group-addon button" style='color:blue;border-color: white;background-color: white;'>选择</a>
        </div>`;
  let Comp = MW.extend(require('form/default/InputField'), {
    protectedDefaults: {
      btnLabel: '选择',
      isFormField: true
    },
    _renderBody: function (dd,edit) {
      let html = HTML;
      let me = this;
      let enableInput = me.$dd.enableInput;
      if(enableInput){
        html = inputHtml
      }
      let el = $(html);

      el.find("a.button").click(function ($event) {
        if (dd.action) {
          if(window.PF && window.PF.invokeFormAction)
          {
            window.PF.invokeFormAction(dd.action, me.$form);
          }
        }
        if (dd.script) {
          let fn=me.$form.scriptContextEval(dd.script);
          if ($.isFunction(fn)) {
            fn.call(me.$form,$event);
          }
        }
      });
      me.el=el;
      return el;
    },
    _getValue() {
      if(this.$dd.enableInput) {
        return this.el.find("input").val();
      }else{
        return this.el.find(".value").text();
      }
    },
    _setValue(v) {

      if(this.$dd.enableInput) {
        this.el.find("input").val(v);
      }else{
        this.el.find(".value").text(v);
      }
    }
  });
  module.exports = Comp;
});

$WR.defineType({
  id: wid,
  xtype: 'CommonButtonField',
  designer: 'DesignerCommonButtonField'
});



// WEBPACK FOOTER //
// ./src/common/formWidget/CommonButonField.js